import React, {Component} from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import {Modal} from "react-bootstrap";


class InformationMailModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customer: {},
            informationMail: false,
            company: this.props.isSmart ? "Smart Dönüşüm" : "Kolaysoft",
        }
        this.saveClicked = this.saveClicked.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            informationMail: this.props.informationMail,
            isSmart: this.props.isSmart,
        })
    }

    onChange(e) {
        let value = deepCopyObject(this.state.informationMail)
        this.setState({informationMail: !value});
    }

    saveClicked() {
        let self = this;
        const data = {};
        data.recordId = this.props.currentUser.customerId;
        data.informationMail = this.state.informationMail
        if (data.informationMail === null) {
            data.informationMail = false;
        }
        let params = {
            url: `/customer/saveInformationMail`,
            data: data,
            method: 'post'
        };
        request(params)
            .then(() => this.props.toggleModal())
            .catch(function (error) {
                showAxiosError(error);
            });
        this.props.informationMailChange(this.state.informationMail);
    }

    render() {
        return (

            <Modal show={this.props.informationMailModal} size="xl">
                <Modal.Header>
                    <h2 style={{marginBottom: '20px'}}>Bilgilendirme Maili Durumu</h2>
                </Modal.Header>
                <Modal.Body>
                        <Col xs={12} style={{overflowY: 'scroll', maxHeight: '600px', width: '100%', padding: '1% 4% 1% 4%'}}>
                            <Row className="kolaysoft-logo-layout"></Row>
                            <Row className="top-buffer">
                                <h3 className="text-center text-uppercase">Kişisel Verilerin İşlenmesine Yönelik
                                    Aydınlatma Metni</h3>
                            </Row>

                            <Row className="top-buffer">
                                <p className="text-center">{this.state.company} Teknoloji A.Ş. (“{this.state.company}”) olarak siz değerli
                                    müşterilerimizin kişisel
                                    verilerinin korunmasına önem veriyor ve sizleri 6698 sayılı Kişisel Verilerin
                                    Korunması Kanunu (“KVKK”)
                                    kapsamında bilgilendirmek istiyoruz.
                                </p>
                            </Row>

                            <Row className="top-buffer">
                                <ol className="list-group">
                                    <li className="list-group-item top-buffer">Kişisel Veriler Kanunu</li>
                                    <Row style={{padding: "15px 10%"}}>
                                        <p className="text-left">6698 Sayılı Kişisel Verilerin Korunması Kanunu
                                            (‘’KVKK’’) 24 Mart 2016 tarihinde
                                            kabul edilmiş, 7 Nisan 2016 tarihli 29677 sayılı Resmi Gazete’ de
                                            yayınlanmıştır. KVKK’ nın bir kısmı
                                            yayın tarihinde, bir kısmı ise 7 Ekim 2016’da yürürlüğe girmiştir.
                                        </p>
                                    </Row>

                                    <li className="list-group-item top-buffer">Kişisel Veri nedir?</li>
                                    <Row style={{padding: "10px 3%"}}>
                                        <p className="text-left">KVKK Kapsamında kişisel veri, kimliği belirli veya
                                            belirlenebilir gerçek kişiye ilişkin
                                            her
                                            türlü bilgiyi (“Kişisel Veri”) ve bunun bir özel türü olan Özel
                                            Nitelikli
                                            Kişisel Veri ise, ırk, etnik
                                            köken, siyasi düşünce, felsefi inanç, din, mezhep veya diğer inançlar,
                                            kılık
                                            ve kıyafet, dernek, vakıf
                                            ya da
                                            sendika üyeliği, sağlık, cinsel hayat, ceza mahkûmiyeti ve güvenlik
                                            tedbirleriyle ilgili verileriniz ile
                                            biyometrik ve genetik verilerinizi (“Özel Nitelikli Kişisel Veri”) ifade
                                            eder. Bu Aydınlatma Metni
                                            kapsamında Kişisel Verileriniz için yapılan açıklamalar Özel Nitelikli
                                            Kişisel Verilerinizi de
                                            kapsamaktadır.
                                        </p>
                                    </Row>

                                    <li className="list-group-item top-buffer">Kişisel Verilerin Hangi Amaçla
                                        İşleneceği
                                    </li>
                                    <Row style={{padding: "10px 3%"}}>
                                        <p className="text-left">Toplanan kişisel verileriniz, {this.state.company} ve
                                             {" "+ this.state.company + " "}
                                            ile iş ilişkisi içerisinde olan
                                            kişilerin hukuki ve ticari güvenliğinin temini; {this.state.company}’ un insan
                                            kaynakları politikalarının
                                            yürütülmesinin temini; {this.state.company}’ un ticari ve iş stratejilerinin
                                            belirlenmesi ve uygulanması
                                            amaçlarıyla
                                            KVK Kanunu’nun 5. ve 6. maddelerinde belirtilen kişisel veri işleme
                                            şartları
                                            ve amaçları dâhilinde
                                            işlenecektir.
                                            Toplanan kişisel verileriniz; Şirketimiz tarafından sunulan ürün ve
                                            hizmetlerden sizleri faydalandırmak
                                            için
                                            gerekli çalışmaların iş birimlerimiz tarafından yapılması, Şirketimiz
                                            tarafından sunulan ürün ve
                                            hizmetlerin
                                            sizlerin beğeni, kullanım alışkanlıkları ve ihtiyaçlarına göre
                                            özelleştirilerek sizlere önerilmesi,
                                            Şirketimizin ve Şirketimizle iş ilişkisi içerisinde olan kişilerin
                                            hukuki ve
                                            ticari güvenliğinin temini
                                            (Şirketimiz tarafından yürütülen iletişime yönelik idari operasyonlar,
                                            Şirkete ait lokasyonların
                                            fiziksel
                                            güvenliğini ve denetimini sağlamak, iş ortağı/müşteri/tedarikçi (yetkili
                                            veya çalışanları) değerlendirme
                                            süreçleri, hukuki uyum süreci, mali işler v.b.), Şirketimizin ticari ve
                                            iş
                                            stratejilerinin belirlenmesi
                                            ve
                                            uygulanması ile Şirketimizin insan kaynakları politikalarının
                                            yürütülmesinin
                                            temini amaçlarıyla iş
                                            ortaklarımıza, tedarikçilerimize, {this.state.company}’ un yurt dışındaki
                                            şirketlerine,
                                            hissedarlarımıza, kanunen
                                            yetkili kamu kurumları ve özel kişilere, KVK Kanunu’nun 8. ve 9.
                                            maddelerinde belirtilen kişisel veri
                                            işleme
                                            şartları ve amaçları çerçevesinde aktarılabilecektir.
                                        </p>
                                    </Row>

                                    <li className="list-group-item top-buffer">Kişisel Veri Toplamanın Yöntemi ve
                                        Hukuki
                                        Sebebi
                                    </li>
                                    <Row style={{padding: "10px 3%"}}>
                                        <p className="text-left"> Kişisel verileriniz Şirketimiz tarafından farklı
                                            kanallarla ve farklı hukuki sebeplere
                                            dayanarak; sunduğumuz ürün ile hizmetleri geliştirmek ve ticari
                                            faaliyetlerimizi yürütmek amacıyla
                                            toplanmaktadır. Bu hukuki sebeple toplanan kişisel verileriniz 6698
                                            sayılı
                                            Kanun’un 5. ve 6.
                                            maddelerinde
                                            belirtilen kişisel veri işleme şartları ve amaçları kapsamında bu
                                            Aydınlatma
                                            Metni’ nin 2. maddesinde
                                            belirtilen amaçlarla da işlenebilmekte ve aktarılabilmektedir.
                                        </p>
                                    </Row>

                                    <li className="list-group-item top-buffer">Veri Sahibi Olarak KVKK’ nın 11.
                                        Maddesinde Sayılan Haklarınız Nelerdir?
                                    </li>
                                    <Row style={{padding: "10px 3%"}}>
                                        <p className="text-left">Kişisel verisi işlenen gerçek kişilerin KVKK’nın
                                            11.
                                            maddesi uyarıca sahip olduğu
                                            haklar
                                            aşağıdaki gibidir;</p>
                                        <ul>
                                            <li>Kişisel veri işlenip işlenmediğini öğrenme</li>

                                            <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme</li>

                                            <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun
                                                kullanılıp
                                                kullanılmadığını öğrenme
                                            </li>

                                            <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü
                                                kişileri bilme
                                            </li>

                                            <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların
                                                düzeltilmesini isteme ve bu
                                                kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü
                                                kişilere
                                                bildirilmesini isteme
                                            </li>

                                            <li>KVKK ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş
                                                olmasına
                                                rağmen, işlenmesini gerektiren
                                                sebeplerin ortadan kalkması hâlinde kişisel verilerin silinmesini
                                                veya
                                                yok edilmesini isteme ve bu
                                                kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü
                                                kişilere
                                                bildirilmesini isteme
                                            </li>

                                            <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz
                                                edilmesi suretiyle kişinin
                                                kendisi
                                                aleyhine bir sonucun ortaya çıkmasına itiraz etme
                                            </li>

                                            <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara
                                                uğraması hâlinde zararın
                                                giderilmesini
                                                talep etme
                                            </li>
                                        </ul>
                                    </Row>
                                </ol>
                            </Row>

                            <Row className="top-buffer">
                                <h4 className="text-center text-primary">Haklarınıza ilişkin taleplerinizi {this.state.company + " "}
                                    için linkte yer alan formu
                                    doldurup, formda belirtilen yöntemlerle
                                    iletmeniz durumunda, talebin niteliğine göre en kısa sürede ve en geç otuz gün
                                    içinde
                                    sonuçlandıracaktır</h4>
                            </Row>


                            <Row className="top-buffer">
                                <h3 className="text-left text-uppercase">{this.state.company} kişisel verilerin korunması ve
                                    gizlilik bildirgesi</h3>

                                <Row className="top-buffer">
                                    <h4 className="text-left">Temel Bilgiler</h4>

                                    <p>
                                        {this.state.company} Teknoloji A.Ş. olarak bizler (bundan böyle “{this.state.company}” veya “biz”
                                        olarak anılacaktır), kişisel
                                        verilerin korunmasına azami önem vermekte ve kişisel verilerin korunmasında
                                        ülkemizde geçerli 6698
                                        sayılı
                                        Kişisel Verilerin Korunması Kanunu ve buna bağlı mevzuat başta olmak üzere
                                        harfiyen uymaktayız.
                                        Kişisel verilerinizi;
                                    </p>

                                    <ul>
                                        <li>Hukuka ve dürüstlük kurallarına uygun olma</li>
                                        <li>Doğru ve gerektiğinde güncel olma</li>
                                        <li>Belirli, açık ve meşru amaçlar için işlenme</li>
                                        <li>İşlendikleri amaçla bağlantılı, sınırlı ve ölçülü olma</li>
                                        <li>İlgili mevzuatta öngörülen veya işlendikleri amaç için gerekli olan süre
                                            kadar muhafaza edilme
                                        </li>
                                        <p>ilkelerine göre işlemekteyiz.</p>
                                    </ul>

                                    <p> Web sitemiz, uygulamalarımız ve hizmetlerimiz kullanıldığında kişisel
                                        veriler
                                        sadece gerekli olduğu
                                        durumlarda toplanır ve amaca uygun şekilde işlenir.</p>
                                    <p>
                                        Kişisel veriler, kimliği belirli veya belirlenebilir gerçek kişiye
                                        ilişkin her türlü bilgidir ve sizin kişisel olarak tanımlanabilmenizi
                                        sağlayan
                                        veya sizinle bağlantılı
                                        olan verilerdir.
                                    </p>
                                </Row>
                            </Row>

                            <Row className="top-buffer">
                                <h4>Kişisel Verilerin Korunması ile İlgili Yetkili Merci:</h4>

                                <Col xs={6} md={3}>
                                    <p>{this.state.isSmart ? "Smart Dönüşüm Teknoloji A.Ş.\n" +
                                        "BAĞLICA MAHALLESİ ÇAMBAYIRI CADDESİ *\n " +
                                        "NEVA SİTESİ \n" +
                                        "Etimesgut-Ankara / Türkiye\n" :
                                        "Kolaysoft Teknoloji A.Ş.\n" +
                                        "A.T.G.B Üniversiteler Mah.\n" +
                                        "1605.Cad. No:3 / 201 – 204\n" +
                                        "Cyberpark Vakıf Binası,\n" +
                                        "06800, Bilkent\n" +
                                        "Çankaya / Ankara"}

                                    </p>

                                    <p>{this.state.isSmart ? "T: 0850 259 93 93": "T: 0850 259 90 90"}</p>
                                    <p>F: 0850 259 91 91</p>
                                    <p>{this.state.isSmart? "E: entegrator@smartdonusum.com ": "E: info@kolaysoft.com.tr"}</p>
                                </Col>
                            </Row>

                            <Row className="top-buffer">
                                <h4 className="text-left text-uppercase">Ek Bilgiler - İletişim Bilgileri</h4>
                                <p>Güveniniz bizim için önemlidir. Bu nedenle kişisel verilerinizin işleme alınması
                                    ile
                                    ilgili olarak her zaman
                                    sorularınıza yanıt vermek arzusundayız. Bu veri koruma açıklamasında yanıt
                                    alamadığınız sorular varsa veya
                                    bir konuya ilişkin daha detaylı bilgi almak istediğiniz zaman lütfen bizimle
                                    bağlantı kurunuz</p>
                            </Row>

                            <Row className="top-buffer">
                                <h4>Güvenlik Uyarısı</h4>
                                <p>Tüm teknik ve organizasyonel olanaklara başvurarak kişisel verilerinizi üçüncü
                                    kişilerce erişilmeyecek
                                    şekilde kaydetmek çabasındayız. E-posta aracılığıyla iletişim esnasında veri
                                    güvenliği tarafımızdan tam
                                    olarak güvence altına alınamadığı için gizli bilgiler için size posta yolunu
                                    tavsiye
                                    ediyoruz.</p>
                            </Row>
                        </Col>

                    <Col style={{padding:'15px'}}>
                        <Col xs={6} >
                            <FormGroup>
                                <Label style={{padding:'0.000001px'}} sm={9} for="informationMail">Bilgilendirme maili almak istiyorum.</Label>
                                <Input type="checkbox"
                                       checked={this.state.informationMail}
                                       onChange={() => this.onChange()}/>{' '}
                            </FormGroup>
                        </Col>

                        <Col xs='10' sm={6} style={{textAlign: 'right'}}>
                            <button className='newWarningButton confirm blinker'
                                    onClick={() => this.saveClicked()}>
                                Onayla
                            </button>
                        </Col>
                    </Col>

                </Modal.Body>
            </Modal>
        );
    }


}

export default InformationMailModal;